import { render, staticRenderFns } from "./DiscussionCommentForm.vue?vue&type=template&id=270b1308&"
import script from "./DiscussionCommentForm.vue?vue&type=script&lang=js&"
export * from "./DiscussionCommentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports